/* ── Quiz data — 3 questions per layer ── */

export const externalQuiz = [
  {
    q: "Jaka powinna być proporcja długości tułowia do wysokości w kłębie u owczarka niemieckiego?",
    options: ["100-105%", "110-117%", "120-130%", "95-100%"],
    correct: 1,
    explanation: "Prawidłowa proporcja to 110-117%, co nadaje rasie charakterystyczną, lekko prostokątną sylwetkę."
  },
  {
    q: "Co to jest kłąb i dlaczego jest ważny?",
    options: [
      "Najniższy punkt brzucha — chroni narządy",
      "Połączenie ogona z zadem — stabilizuje ruch",
      "Najwyższy punkt grzbietu przy łopatkach — punkt pomiaru wysokości",
      "Środek grzbietu — przenosi napęd"
    ],
    correct: 2,
    explanation: "Kłąb to najwyższy punkt grzbietu w okolicy łopatek — punkt odniesienia do mierzenia wysokości psa. Wysoki kłąb zapewnia lepsze kątowanie łopatki."
  },
  {
    q: "Pod jakim kątem powinna być ustawiona łopatka owczarka?",
    options: ["90°", "60°", "45°", "30°"],
    correct: 2,
    explanation: "Łopatka pod kątem ok. 45° do poziomu zapewnia optymalny zasięg ruchu kończyny przedniej."
  }
];

export const skeletalQuiz = [
  {
    q: "Dlaczego lędźwie owczarka powinny być krótkie i mocne?",
    options: [
      "Bo długie lędźwie wyglądają źle na wystawie",
      "Bo przenoszą napęd z tylnych kończyn — krótkie = stabilny, sprężysty kłus",
      "Bo chronią nerki przed urazami",
      "Bo ułatwiają oddychanie"
    ],
    correct: 1,
    explanation: "Lędźwie to most napędowy - przenoszą siłę z kończyn tylnych na resztę ciała. Krótkie i mocne = wydajny ruch bez kołysania zadu."
  },
  {
    q: "Co to jest dysplazja stawu biodrowego i dlaczego jest ważna?",
    options: [
      "Złamanie kości udowej — wymaga operacji",
      "Wada stawu — głowa kości udowej nie pasuje do panewki miednicy",
      "Zapalenie mięśni uda — leczy się tabletkami",
      "Problem ze stawem kolanowym — rzadki u owczarków"
    ],
    correct: 1,
    explanation: "Dysplazja to wada rozwojowa stawu biodrowego — głowa kości udowej nie pasuje do panewki. RTG HD jest obowiązkowe w hodowli owczarków."
  },
  {
    q: "Jaki kąt łopatka–ramię zapewnia najdłuższy krok przedni?",
    options: ["45°", "60°", "90°", "120°"],
    correct: 2,
    explanation: "Kąt łopatka–ramię ok. 90° = optymalny zasięg ruchu kończyny przedniej. To jeden z najważniejszych elementów oceny budowy."
  }
];
